module.exports = __webpack_public_path__ + "media/images/applicant/icon-arrow-right-yellow-17585dc51f714f3da09b82ad6c06b97e.svg";